
/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createOpenModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';


const openModal = createOpenModalAction('ResourceMetaDataModal');

export const startResourceMetaDataModal = (resourceConnectId) => dispatch => {
    dispatch({
        type: actions.START_RESOURCE_META_DATA_MODAL,
        payload: { resourceConnectId }
    })
    dispatch(openModal());
}